import React from "react";
import { VStack, Flex, Text } from "@sqymagma/elements";
import { WidgetBox } from "@components";
import { Icon } from "@elements";
import { useApp } from "@contexts";

import NewsItem from "./NewsItem";
import * as S from "./style";

const NewsWidget = () => {
  const { news } = useApp();

  if (!news.length) return null;

  return (
    <WidgetBox>
      <VStack>
        <Flex justifyContent="space-between" alignItems="center">
          <Text textStyle="subtitle01" color="text01" weight="bold">
            Tablón de novedades
          </Text>
          <Icon name="news" size="medium" color="ui01" />
        </Flex>
        <S.NewsWrapper gap="xs" pt="xs" pb="xxs">
          {news.map((newsItem, idx) => (
            <NewsItem
              newsText={newsItem.text}
              start={newsItem.start}
              key={idx}
            />
          ))}
        </S.NewsWrapper>
      </VStack>
    </WidgetBox>
  );
};

export default NewsWidget;
